/**
 * FAT #19 Phase 3c — Shell-level route guard (loosened).
 *
 * DESIGN LOCK (do not re-tighten):
 *   User quote (2026-07-12):
 *   "Expired users should still SEE the dashboard, leads list, and every
 *    other READ page — with the locked CTAs surfaced as pills. Never
 *    hard-redirect a signed-in user off a READ page just because their
 *    Beta lapsed. Education over frustration."
 *
 * What this gate does now:
 *   1. Every authenticated user is allowed through to every READ page.
 *   2. Per-capability enforcement lives on the CTAs themselves via
 *      <CapabilityGate>. WRITE requests are enforced server-side and
 *      surfaced as 402 → /upgrade via the global axios interceptor.
 *   3. Admin-only routes (`/admin/*`) still gate on `is_admin` — but
 *      those routes are declared separately in router.jsx and are NOT
 *      wrapped in this component, so this guard is now a pass-through.
 *
 * If a future developer wants to reintroduce a hard shell-level lockout,
 * READ the quote above and route it through Product first.
 */
import React from "react";

export function SubscriptionGate({ children }) {
  return <>{children}</>;
}

export default SubscriptionGate;
